import {useRef, useState} from 'react'
import {message, Switch} from "antd";
import {
  SActionBtn,
  SLowcodeList, SMessage,
  STableActions,
} from 'shj-components'
import {config} from './config.tsx'
import {AddOrEdit} from "./AddOrEdit";
import {getSeatIpConfigPage, seatIpConfigDel} from "@/services/crmTool.ts";
import {apiData2Table} from "@/utils/data.ts";

export default function ChannelCallBack() {
  const listRef = useRef()
  const [open, setOpen] = useState(false)
  const [record, setRecord] = useState({})

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      getSeatIpConfigPage({params: {pageId: current, pageSize}, data: {...query}}).then((res: any) => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const onAdd = () => onEdit()
  const onEdit = (record = {}) => {
    setOpen(true)
    setRecord(record)
  }

  //  表格事件: 删除
  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
        return seatIpConfigDel(id).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const onChangeStatus = (enabled: boolean, record) => {
    SMessage.confirm({
      title: '修改状态',
      content: `是否确认${enabled ? '启用' : '禁用'}该数据`,
      onOk: () => {
       // return productCategoryUpdateById( {...record, enabled}).then((res: any) => {
       //    message.success(res.message || '操作成功');
       //    listRef.current?.reload()
       //  })
      },
    });
  }

  const extensions = {
    request: {fetchList},
    events: {onAdd},
    status: {
      selectedDisabled: ({selectedRowKeys}: any) => !selectedRowKeys.length,
      radioDisabled: ({selectedRowKeys}: any) => selectedRowKeys.length !== 1,
    },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return <Switch checked={v} onClick={(checked) => onChangeStatus(checked, record)}/>
      },
      actionRender(_, record: Record<string, any>) {
        return (
            <STableActions>
              <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
              <SActionBtn danger onClick={() => onDel(record.id)}>删除</SActionBtn>
            </STableActions>
        )
      },
    },
  }
  return (
      <>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
        <AddOrEdit open={open} onReload={listRef.current?.reload} setOpen={(open: boolean) => setOpen(open)} record={record}/>
      </>
  )
}
